import { createMarketGroupsApi } from "@/v2/api/metadata/market-groups";
import { createMarketsApi } from "@/v2/api/metadata/markets";
import { createSportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createDialogs } from "./dialogs";
import { createFilters } from "./filters";

const LS_MARKET_GROUPS_FILTERS_KEY = Symbol("market-groups-filters");

export function createMarketGroupsView(ctx: BackofficeContext): EntityView {
  const marketGroupsApi = createMarketGroupsApi(ctx);
  const sportsApi = createSportsApi(ctx);
  const marketsApi = createMarketsApi(ctx);

  return {
    id: "market-groups",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, marketGroupsApi, sportsApi, marketsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_MARKET_GROUPS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: marketGroupsApi.grid,
      },
    ],
  };
}
